<template>
  <Form
    class="c-form c-form--form"
    ref="form"
    :model="cForm.model"
    :rules="cForm.rules"
    :label-width="100"
  >
    <Form-item label="标题" prop="title">
      <Input
        class="c-form__input"
        v-model.trim="cForm.model.title"
        placeholder="请输入标题"
      />
    </Form-item>
    <Form-item label="状态" prop="status">
      <Select
        class="c-form__input"
        placeholder="请选择状态"
        clearable
        v-model="cForm.model.status"
      >
        <Option
          v-for="item in dicts.PublishStatus"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        >
          {{ item.label }}
        </Option>
      </Select>
    </Form-item>

    <Form-item label="封面" prop="pictureId">
      <div v-if="cForm.model.pictureId">
        <img :src="getImgSrc">
        </img>
      </div>
      <c-uploader
        class="c-form__input"
        :key="`picture-${cForm.id}`"
        :default-file-ids="cForm.model.pictureId"
        @change="
          value => {
            handleFormUploaderChange('pictureId', value);
          }
        "
      />
    </Form-item>

    <Form-item label="描述" prop="description">
      <Input
        class="c-form__input"
        type="textarea"
        v-model.trim="cForm.model.description"
        placeholder="请输入描述"
      />
    </Form-item>

    <Form-item label="直接跳转链接" prop="link">
      <Input
        class="c-form__input"
        v-model.trim="cForm.model.link"
        placeholder="客户端点击链接详情直接跳转; 例如: https://www.baidu.com"
     />
    </Form-item>
    <Form-item label="内容" prop="content">
      <c-editor
        :html="cForm.model.content"
        @change="
          html => {
            $set(cForm.model, 'content', html);
            $refs.form.validateField('content');
          }
        "
      ></c-editor>
    </Form-item>
    <Form-item>
      <Button class="u-mr5" type="primary" @click="submit">
        保存
      </Button>
      <Button
        @click="
          id ? $helpers.goBack() : $router.push(`/dresses/brands/activity/list`)
        "
      >
        返回
      </Button>
    </Form-item>
  </Form>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import FormMixin from "view-ui-admin/src/mixins/form";
import { mapState } from "vuex";
import helpers from "@/utils/helpers";

const module = "activity";

@Component({
  mixins: [RouteParamsMixin, FormMixin],
  computed: mapState({
    detail: state => state[module].detail,
    getImgSrc: state => {
          const url = helpers.getImageUrl({
            id: state[module].detail.pictureId,
            width: 500,
            height: 200
          });
        console.log(url);
        return url;
    },
  })
})
export default class extends Vue {
  data() {
    return {
      cForm: {
        model: this.getFormInitModel(),
        rules: {
          description: [
            {
              required: true,
              message: "描述不能为空"
            }
          ],
          pictureId: [
          {
              required: true,
              message: "封面不能为空"
            }
          ],
          title: [
            {
              required: true,
              message: "标题不能为空"
            }
          ],
          content: [
            {
              required: true,
              message: "内容不能为空"
            }
          ]
        }
      }
    };
  }

  created() {
    this.id && this.getDetail(module, this.id);
  }

  getFormInitModel() {
    return {
      originalPrice: 0,
      price: 0,
      stock: 0,
      status: 1,
      content: ""
    };
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const {
          model: { id, ...restModel }
        } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: restModel
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
        this.$router.go('/dresses/brands/activity/list');
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
